module.exports = __webpack_public_path__ + "img/clipboard.fe0e3e60.png";